var map = {
	"./determine/Detoxification.jpg": 4595,
	"./determine/Hydration.jpg": 1703,
	"./determine/MentalFitness.jpg": 9820,
	"./determine/Movement.jpg": 8130,
	"./determine/Nature.jpg": 7964,
	"./determine/Nutrition.jpg": 5245,
	"./determine/Relationships.jpg": 9416,
	"./determine/RestSelfCare.jpg": 9378,
	"./determine/Sleep.jpg": 4260,
	"./determine/Vision.jpg": 9329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8960;